import { render, staticRenderFns } from "./RecordKpi.vue?vue&type=template&id=fdd40c20&scoped=true"
import script from "./RecordKpi.vue?vue&type=script&lang=js"
export * from "./RecordKpi.vue?vue&type=script&lang=js"
import style0 from "./RecordKpi.vue?vue&type=style&index=0&id=fdd40c20&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "fdd40c20",
  null
  
)

export default component.exports